module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Invoice Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [_c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Invoice Number"
    },
    model: {
      value: (_vm.InvoiceNoFilter),
      callback: function($$v) {
        _vm.InvoiceNoFilter = $$v
      },
      expression: "InvoiceNoFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": " Assignment No."
    },
    model: {
      value: (_vm.assignmentFilter),
      callback: function($$v) {
        _vm.assignmentFilter = $$v
      },
      expression: "assignmentFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.invoiceStatusdataList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.invstatusFilter),
      callback: function($$v) {
        _vm.invstatusFilter = $$v
      },
      expression: "invstatusFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    staticClass: "mt-2",
    attrs: {
      "list": _vm.assignmentStatusdataList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Assignment Status"
    },
    model: {
      value: (_vm.assignstatusFilter),
      callback: function($$v) {
        _vm.assignstatusFilter = $$v
      },
      expression: "assignstatusFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    staticClass: "mt-2",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common BL/Container Search"
    },
    model: {
      value: (_vm.CommonFilter),
      callback: function($$v) {
        _vm.CommonFilter = $$v
      },
      expression: "CommonFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('b-pagination', {
    staticClass: "mt-3",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "limit": "20",
      "align": "right",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', [(_vm.invoiceTallyList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('INVOICE_BILLING', 'Export As Excel')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceTallyList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mr-1 mb-1",
    attrs: {
      "disabled": _vm.ExcelContainerWiseBtnName != 'Export ContainerWise Report' ?
        true :
        false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports(
          'INVOICE_BILLING_CONTAINERWISE',
          'Export ContainerWise Report'
        )
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelContainerWiseBtnName) + "\n                "), (_vm.ExcelContainerWiseBtnName != 'Export ContainerWise Report') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-button', {
    staticClass: "pull-right mr-1 mb-1",
    attrs: {
      "disabled": _vm.ExcelPendingReverseBtnName != 'Export Pending Reverse Bill' ?
        true :
        false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReportsReverse(
          'PENDING_REVERSE_BILLING',
          'Export Pending Reverse Bill'
        )
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelPendingReverseBtnName) + "\n                "), (_vm.ExcelPendingReverseBtnName != 'Export Pending Reverse Bill') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e(), _c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(COUNT : " + _vm._s(_vm.$store.getters["common/getAllPendingReverseTallyList"]) + ")\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBSJBtnName != 'Failed SE REPORT' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getFailedSalesExpenseLogList('Excell')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelBSJBtnName) + "\n                "), (_vm.ExcelBSJBtnName != 'Failed SE REPORT') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelJVBtnName != 'JV REPORT' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getJVList('Excell')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.ExcelJVBtnName) + "\n                "), (_vm.ExcelJVBtnName != 'JV REPORT') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1 mr-1",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.newReverseTally()
      }
    }
  }, [_vm._v("\n                New Reverse Tally\n              ")]), _vm._v(" "), (
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('span', [_c('br'), _vm._v("Updated Data From :\n                "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_c('u', [_vm._v(_vm._s("25-Nov-2022"))])])]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalTallyCount) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.invoiceTallyList,
      "fields": _vm.InvoiceFields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.jobNo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showInvoiceDet(row1.item)
            }
          }
        }, [_vm._v("Item Data")]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.jobNo
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.jobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.jobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.jobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.jobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.jobNo
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.jobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.jobNo,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' && row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                  Client Name : " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                  Overseas Agent : " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                  " + _vm._s(row11.item.clientName) + "\n                  "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "Status",
      fn: function(row123) {
        return [(row123.item.Status != '' && row123.item.Status != null) ? _c('b', [(row123.item.Status == 'Active') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (row123.item.Status == 'Inactive') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("In-Active")]) : _vm._e()]) : _vm._e(), _c('br'), _vm._v(" "), (
          row123.item.manualBilling != '' && row123.item.manualBilling != null
        ) ? _c('b', [_vm._v("\n                  " + _vm._s(row123.item.manual_status) + "\n                  ")]) : _vm._e()]
      }
    }, {
      key: "ffInvoiceClosed",
      fn: function(row2) {
        return [(row2.item.jobType.split(',').includes('FF')) ? _c('span', [_vm._v("FF :-\n                  " + _vm._s(row2.item.ffInvoiceClosed == "1" ? "Received" : "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('CC')) ? _c('span', [_vm._v("CC :-\n                  " + _vm._s(row2.item.ccInvoiceClosed == "1" ? "Received" : "Not-Received")), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.jobType.split(',').includes('TPT')) ? _c('span', [_vm._v("TPT :-\n                  " + _vm._s(row2.item.tptInvoiceClosed == "1" ? "Received" : "Not-Received"))]) : _vm._e()]
      }
    }, {
      key: "billingSeries",
      fn: function(row1000) {
        return [(row1000.item.BillingSeries) ? _c('div', [_c('b', [_c('u', [(
          row1000.item.BillingSeries && row1000.item.invoice_pdf == 'Yes'
        ) ? _c('a', {
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/Common_Invoices_doc/" + (row1000.item.BillingSeries.replaceAll('/', '_')) + ".pdf"))
            }
          }
        }, [_vm._v(_vm._s(row1000.item.BillingSeries))]) : (
          row1000.item.BillingSeries && row1000.item.invoice_pdf == 'No'
        ) ? _c('a', [_vm._v("\n                        " + _vm._s(row1000.item.BillingSeries) + "\n                      ")]) : _vm._e()])]), _c('br'), _vm._v(" "), (row1000.item.invoice_pdf == 'Yes') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("PDF : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v(_vm._s(row1000.item.invoice_pdf))])]), _c('br')], 1) : _vm._e(), _vm._v(" "), (row1000.item.invoice_pdf == 'No') ? _c('span', [_c('b', {
          style: ('color:black')
        }, [_vm._v("PDF : ")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v(_vm._s(row1000.item.invoice_pdf))])]), _c('br')], 1) : _vm._e()]) : _c('span', [_vm._v("-----------")]), _vm._v(" "), _c('b-button', {
          staticClass: "mt-1",
          attrs: {
            "variant": "outline-primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(
                row1000.item.allModuleId,
                row1000.item.newContainerFlow,
                row1000.item.isConsolidation,
                row1000.item.mainSalesSeries,
                row1000.item.BillingSeries
              )
            }
          }
        }, [_vm._v(_vm._s("Show Invoice"))])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": "Submit Your Reason",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), (_vm.incompleteJobBill) ? _c('h4', {
    staticClass: "error"
  }, [_c('small', [_vm._v("Invoice Not added for ")]), _vm._v(" " + _vm._s(_vm.incompleteJobBill) + "\n        "), _c('small', [_vm._v(" Please Kindly Check..!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason for closing assignment billing",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.closingReason),
      callback: function($$v) {
        _vm.closingReason = $$v
      },
      expression: "closingReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.closingReason ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.closeBillOk
    }
  }, [_vm._v("\n        Confirm & Close Billing")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v("\n        Cancel")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "otherTallyInvCharges-modal",
    attrs: {
      "id": "otherTallyInvCharges-modal",
      "title": _vm.modal_title + _vm.modal_JobNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Split Status")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.InvItemist), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.PrdDesc))]), _vm._v(" "), _c('td', [(item1.SplitStatus == 'YES') ? _c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showInvoiceSplitDet(
            item1,
            'Invoice',
            1,
            item1.InvDet.inv_no,
            item1.AssNo,
            'Inv'
          )
        }
      }
    }, [_vm._v(_vm._s(item1.SplitStatus))]) : _c('b', [_vm._v(_vm._s(item1.SplitStatus))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.HsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.TotAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.GstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.IgstAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.SgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CesRt) + " / " + _vm._s(item1.CesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.AssAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.TotItemVal) + " " + _vm._s(item1.OrgCntry))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideInvoiceDet
    }
  }, [_vm._v("\n                Close")])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    ref: "otherTallyInvSplitCharges-modal",
    attrs: {
      "id": "otherTallyInvSplitCharges-modal",
      "title": _vm.modal_title + _vm.modal_JobNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.isLoadinghide) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")]), _vm._v(" "), _c('th', [_vm._v("JOB")]), _vm._v(" "), _c('th', [_vm._v("JOB AMT")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.InvItemSplitList), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.PrdDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.Barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.HsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.TotAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.GstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(item1.IgstAmt) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.SgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.CesRt) + " / " + _vm._s(item1.CesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.AssAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.TotItemVal) + " " + _vm._s(item1.OrgCntry))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.JOBNO))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.JOBAMT))])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideInvoiceSplitDet
    }
  }, [_vm._v("\n                Close")])], 1)], 1)])])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopTally",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeBillOk
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d1f4d72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewInvoiceDetails.vue
// module id = 2430
// module chunks = 0